import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { recordingsModel } from '../../model';
import { authUserModel } from '../../../../entities/auth-user';

import {
  getFilterOwnerResults,
  getFilterSearchResults,
  getSortResults,
} from '../../lib';

import { RecordCategory } from '../../../../entities/recordings';

import { RecordsNotFound } from './RecordsNotFound';

import { RecordsGrid, RecordsList } from './RecordsView';

import { useRecordsView } from '../../hooks';

export const RecordsShared: FC = () => {
  const currentUser = useSelector(authUserModel.selectors.selectUserWithError);

  const records = useSelector(
    recordingsModel.selectors.selectRecordsShared(currentUser.id)
  );

  const sort = useSelector(recordingsModel.selectors.selectSort);

  const filterSearch = useSelector(
    recordingsModel.selectors.selectFilterSearch
  );

  const { view } = useRecordsView();

  const filterOwner = useSelector(recordingsModel.selectors.selectFilterOwner);

  const filteredRecords = useMemo(() => {
    const searchResults = getFilterSearchResults(records, filterSearch);

    const searchOwnerResults = getFilterOwnerResults(
      searchResults,
      filterOwner
    );

    return getSortResults(searchOwnerResults, sort);
  }, [filterSearch, filterOwner, sort, records]);

  return (
    <>
      {filteredRecords.length ? (
        view === 'grid' ? (
          <RecordsGrid
            records={filteredRecords}
            category={RecordCategory.SHARED}
          />
        ) : (
          <RecordsList
            records={filteredRecords}
            category={RecordCategory.SHARED}
          />
        )
      ) : (
        <RecordsNotFound />
      )}
    </>
  );
};
